export default "__VITE_ASSET__DOJssvTI__"